// deps
import React, { ReactElement, memo } from "react";
import cx from "classnames";
import { AriaHidden } from "@swiggy-private/core-ui";

// styles
import styles from "./Message.scss";

// internal deps
import { isEmpty } from "@swiggy-private/payment-core";

export interface MessageProps {
    message: string;
    type?: MESSAGE_TYPES;
    className?: string;
    wrapperClass?: string;
    "data-testid"?: string;
}

export enum MESSAGE_TYPES {
    INFO = "info",
    ALERT = "alert",
}

function Message(props: MessageProps): ReactElement | null {
    if (isEmpty(props.message)) {
        return null;
    }

    const wrapperClass = cx(styles.messageWrapper, props.wrapperClass);
    const messageClass = cx(
        styles.message,
        { [styles.messageAlert]: props.type === MESSAGE_TYPES.ALERT },
        props.className,
    );

    return (
        <AriaHidden as="div" className={wrapperClass}>
            <div className={messageClass} data-testid={props["data-testid"]}>
                {props.message}
            </div>
        </AriaHidden>
    );
}

export default memo(Message);
